export default __webpack_public_path__ + "static/7 - Bojlerben felgyülemlett vízkő-8cd38534511949fa48776aaa6cd946f3.jpg";